import { createSelector } from '@ngrx/store';
import { selectStationFeatureState } from '../reducers';
import { DO_HOP_FEATURED_STATIONS } from '../../../constants/app.constants';
import { selectAppCmsCopy } from './cms.selector';

/* istanbul ignore next  */
export const selectStationsState = createSelector(
  selectStationFeatureState,
  (state) => state.stations,
);

/* istanbul ignore next  */
export const selectStationsStateNoMacs = createSelector(
  selectStationFeatureState,
  (state) =>
    state.stations
      ?.filter((s) => !s.isMac)
      ?.sort((a, b) => {
        return a.fullName > b.fullName ? 1 : a.fullName < b.fullName ? -1 : 0;
      }),
);

/* istanbul ignore next  */
export const selectStationsWithConnectionsState = createSelector(
  selectStationFeatureState,
  (state) =>
    state.stationsWithConnections?.slice().sort((a, b) => {
      return a.fullName > b.fullName ? 1 : a.fullName < b.fullName ? -1 : 0;
    }),
);

/* istanbul ignore next  */
export const selectStationsWithConnectionsStateNoMacs = createSelector(
  selectStationFeatureState,
  (state) => state.stationsWithConnections?.filter((s) => !s.isMac),
);

export const selectN0StationsWithConnections = createSelector(
  selectStationsWithConnectionsState,
  (state) =>
    state
      ?.filter((s) => s.isNorse)
      ?.sort((a, b) => {
        return a.fullName > b.fullName ? 1 : a.fullName < b.fullName ? -1 : 0;
      }),
);

export const selectN0StationsWithConnectionsNoMacs = createSelector(
  selectStationsWithConnectionsState,
  (state) =>
    state
      ?.filter((s) => s.isNorse && !s.isMac)
      ?.sort((a, b) => {
        return a.fullName > b.fullName ? 1 : a.fullName < b.fullName ? -1 : 0;
      }),
);

export const selectDohopFeatureStations = createSelector(
  selectStationsWithConnectionsState,
  selectAppCmsCopy,
  (state, appCopy) => {
    const stationList =
      appCopy?.searchWidgetFull.connectingFeaturedStations ??
      DO_HOP_FEATURED_STATIONS;

    return state
      ?.filter((s) => stationList.includes(s.stationCode))
      ?.sort((a, b) => {
        return a.fullName > b.fullName ? 1 : a.fullName < b.fullName ? -1 : 0;
      });
  },
);

export const selectNearestStation = createSelector(
  selectStationFeatureState,
  (state) => state.nearestStation,
);

/* istanbul ignore next  */
export const selectUserLocation = createSelector(
  selectStationFeatureState,
  (state) => state.userLocation,
);
